import { gql } from "@apollo/client";

export const GET_EMAIL_CHANNELS_CURSOR = gql`
  query EmailChannelsCursor(
    $text: String
    $first: Int!
    $after: String
    $where: QueryEmailChannelsCursorWhereWhereConditions
    $orderBy: [QueryEmailChannelsCursorOrderByOrderByClause!]
  ) {
    emailChannelsCursor(
      text: $text
      first: $first
      after: $after
      where: $where
      orderBy: $orderBy
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        total
        count
        currentPage
        lastPage
      }
      edges {
        cursor
        node {
          id
          username
          exhibition_type_id
          is_active
          is_visible
          relExhibitionType {
            id
            title
          }
        }
      }
    }
  }
`;
